// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentWrapper_wrapper__2DpA3","content":"ContentWrapper_content__JdAho"};